export const SET_USER_ABUSE_PROCESSING = 'SET_USER_ABUSE_PROCESSING'
export const SET_USER_ABUSE_UNRESOLVED_PROCESSING = 'SET_USER_ABUSE_UNRESOLVED_PROCESSING'
export const GET_USER_ABUSE_REPORTS = 'GET_USER_ABUSE_REPORTS'
export const GET_USER_ABUSE_ACCUSED_REPORTS = 'GET_USER_ABUSE_ACCUSED_REPORTS'
export const GET_USER_ABUSE_ACCUSER_REPORTS = 'GET_USER_ABUSE_ACCUSER_REPORTS'
export const SET_USER_ABUSE_REPORTS = 'SET_USER_ABUSE_REPORTS'
export const SET_USER_ABUSE_ACCUSED_REPORT = 'SET_USER_ABUSE_ACCUSED_REPORT'
export const SET_USER_ABUSE_ACCUSER_REPORT = 'SET_USER_ABUSE_ACCUSER_REPORT'
export const SET_USER_ABUSE_ACCUSED_REPORTS = 'SET_USER_ABUSE_ACCUSED_REPORTS'
export const SET_USER_ABUSE_ACCUSER_REPORTS = 'SET_USER_ABUSE_ACCUSER_REPORTS'
export const SET_USER_ABUSE_REPORT = 'SET_USER_ABUSE_REPORT'
export const SET_USER_ABUSE_REPORTS_ERROR = 'SET_USER_ABUSE_REPORTS_ERROR'
export const RESOLVE_USER_ABUSE_REPORT = 'RESOLVE_USER_ABUSE_REPORT'
export const RESOLVE_USER_ABUSE_ACCUSER_REPORT = 'RESOLVE_USER_ABUSE_ACCUSER_REPORT'
export const RESOLVE_USER_ABUSE_ACCUSED_REPORT = 'RESOLVE_USER_ABUSE_ACCUSED_REPORT'
export const GET_USER_ABUSE_UNRESOLVED_COUNT = 'GET_USER_ABUSE_UNRESOLVED_COUNT'
export const SET_USER_ABUSE_UNRESOLVED_COUNT = 'SET_USER_ABUSE_UNRESOLVED_COUNT'

export function setUserAbuseProcessing ({ processing = true } = {}) {
  return {
    type: SET_USER_ABUSE_PROCESSING,
    payload: { processing },
  }
}

export function setUserAbuseUnresolvedProcessing ({ processing = true } = {}) {
  return {
    type: SET_USER_ABUSE_UNRESOLVED_PROCESSING,
    payload: { processing },
  }
}

export function getUserAbuseReports ({ resolved, p, pp } = {}) {
  return {
    type: GET_USER_ABUSE_REPORTS,
    payload: { resolved, p, pp },
  }
}

export function getUserAbuseUnresolvedCount () {
  return {
    type: GET_USER_ABUSE_UNRESOLVED_COUNT,
  }
}

export function setUserAbuseUnresolvedCount ({ data } = {}) {
  return {
    type: SET_USER_ABUSE_UNRESOLVED_COUNT,
    payload: { data },
  }
}

export function getUserAbuseAccusedReports ({ accusedUid, p, pp } = {}) {
  return {
    type: GET_USER_ABUSE_ACCUSED_REPORTS,
    payload: { accusedUid, p, pp },
  }
}

export function getUserAbuseAccuserReports ({ accuserUid, p, pp } = {}) {
  return {
    type: GET_USER_ABUSE_ACCUSER_REPORTS,
    payload: { accuserUid, p, pp },
  }
}

export function setUserAbuseReports ({ data } = {}) {
  return {
    type: SET_USER_ABUSE_REPORTS,
    payload: { data },
  }
}

export function setUserAbuseReportsError ({ data } = {}) {
  return {
    type: SET_USER_ABUSE_REPORTS_ERROR,
    payload: { data },
  }
}

export function setUserAbuseReport ({ reportId, data } = {}) {
  return {
    type: SET_USER_ABUSE_REPORT,
    payload: { reportId, data },
  }
}

export function setUserAbuseAccuserReports ({ data } = {}) {
  return {
    type: SET_USER_ABUSE_ACCUSER_REPORTS,
    payload: { data },
  }
}

export function setUserAbuseAccusedReports ({ data } = {}) {
  return {
    type: SET_USER_ABUSE_ACCUSED_REPORTS,
    payload: { data },
  }
}

export function resolveUserAbuseAccuserReport ({ reportId, resolverAction } = {}) {
  return {
    type: RESOLVE_USER_ABUSE_ACCUSER_REPORT,
    payload: { reportId, resolverAction },
  }
}

export function resolveUserAbuseAccusedReport ({ reportId, resolverAction } = {}) {
  return {
    type: RESOLVE_USER_ABUSE_ACCUSED_REPORT,
    payload: { reportId, resolverAction },
  }
}

export function setUserAbuseAccuserReport ({ reportId, data } = {}) {
  return {
    type: SET_USER_ABUSE_ACCUSER_REPORT,
    payload: { reportId, data },
  }
}

export function setUserAbuseAccusedReport ({ reportId, data } = {}) {
  return {
    type: SET_USER_ABUSE_ACCUSED_REPORT,
    payload: { reportId, data },
  }
}

export function setUsersByQueryError ({ error } = {}) {
  return {
    type: SET_USER_ABUSE_REPORTS_ERROR,
    payload: { error },
  }
}

export function resolveUserAbuseReport ({ reportId, resolverAction } = {}) {
  return {
    type: RESOLVE_USER_ABUSE_REPORT,
    payload: { reportId, resolverAction },
  }
}
